module.exports = __webpack_public_path__ + "static/img/douyin.ae5145a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot/douyin.png
// module id = 53vg
// module chunks = 7